<template>
  <div id="google-translate-element"></div>
</template>

<script>
export default {
  name: "google-translate-element"
}
</script>

<style lang="scss">
  html {
    body {
      top: 0 !important;
      min-height: initial !important;
    }

    body > div.skiptranslate {
      display: none;
    }

    .goog-te-banner-frame {
      display: none;
    }
  }

  .greysite .goog-te-combo {
    background: #dadada;
  }

  #google-translate-element {
    .goog-te-gadget {
      font-size: 0;

      select {
        option {
          font-size: 13px;
        }
      }

      > span {
        display: none;
      }
    }
  }
</style>
